import "@tiptap/extension-text-style";
import {Extension} from "@tiptap/core";

/**
 * Zeilenhöhe als einheitenloser Faktor - muss mit dem Wert im Mail-Wrapper
 * (CampaignMailBuilder::render()) und in der Editor-CSS (app.scss) überein-
 * stimmen, damit Editor und versendete Mail gleich aussehen.
 */
const LINE_HEIGHT_FACTOR = 1.45;

/**
 * Eigene FontSize-Extension für Tiptap v2 - dafür gibt es kein offizielles
 * @tiptap/-Paket (anders als bei FontFamily). Struktur bewusst an der
 * offiziellen @tiptap/extension-font-family angelehnt: globales Attribut
 * auf der textStyle-Marke, Commands setFontSize()/unsetFontSize().
 *
 * @see https://tiptap.dev/api/extensions/font-family (Vorlage/Muster)
 */
const FontSize = Extension.create({
    name: "fontSize",

    addOptions() {
        return {
            types: ["textStyle"],
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => element.style.fontSize,
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize) {
                                return {};
                            }

                            // Zeilenhöhe als Faktor mitgeben: sie berechnet sich
                            // damit aus der gesetzten Schriftgröße selbst. Nötig,
                            // weil Outlook den Zeilenabstand einer vergrößerten
                            // Textstelle sonst beim umgebenden Standard belässt
                            // und die Zeilen zu eng stehen.
                            return {
                                style: `font-size: ${attributes.fontSize}; line-height: ${LINE_HEIGHT_FACTOR}`,
                            };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontSize: (fontSize) => ({chain}) => {
                return chain()
                    .setMark("textStyle", {fontSize})
                    .run();
            },
            unsetFontSize: () => ({chain}) => {
                return chain()
                    .setMark("textStyle", {fontSize: null})
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});

export default FontSize;
